import React from 'react';
import { FiMail, FiPhone } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';

function Footer({ data }) {
  const { t } = useTranslation();
  
  return (
    <footer className="bg-dark-900 text-white py-12" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          {/* Company */}
          <div>
            <h3 
              className="text-3xl font-bold mb-4 tracking-wider"
              style={{
                fontFamily: "'Racing Sans One', cursive",
                color: '#FFFFFF'
              }}
            >
              HADEN
            </h3>
            <p className="text-gray-400">
              {t('footer.company')}
            </p>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold mb-4">{t('footer.contact')}</h4>
            <div className="space-y-2 text-gray-400">
              <div className="flex items-center">
                <FiMail className="mr-2" />
                <a
                  href={`mailto:${data?.email}`}
                  className="hover:text-white transition-colors"
                >
                  {data?.email || 'enquiries@haden.in'}
                </a>
              </div>
              {/* Phone - Only show if phone_visible is true */}
              {data?.phone_visible && data?.phone && (
                <div className="flex items-center">
                  <FiPhone className="mr-2" />
                  <a
                    href={`tel:${data?.phone}`}
                    className="hover:text-white transition-colors"
                  >
                    {data?.phone}
                  </a>
                </div>
              )}
            </div>
          </div>

          {/* Admin */}
          <div>
            <h4 className="font-semibold mb-4">{t('footer.admin')}</h4>
            <a
              href="/admin/login"
              className="text-gray-400 hover:text-white transition-colors"
            >
              {t('footer.adminLogin')}
            </a>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 text-center text-gray-400 text-sm">
          <p>{t('footer.copyright', { defaultValue: `© ${new Date().getFullYear()} HADEN Systems Private Limited. All rights reserved.` })}</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
